import CreateAntField from './CreateAntField';
import CustomSelect from '../CustomSelect';

export default CreateAntField(CustomSelect);
